import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CheckoutState } from './checkout-state.model';

export const selectCheckoutState = createFeatureSelector<CheckoutState>('checkout');

export const selectCheckout = createSelector(selectCheckoutState, (entities) => entities);
